"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { IXContext, triggerIXEvent } from "../interactions";
import { EASING_FUNCTIONS, cj } from "../utils";
import { SliderContext } from "./shared/sliderContext";
const SliderSlide = /*#__PURE__*/ React.forwardRef(function SliderSlide(_param, ref) {
    var { tag = "div", className = "", style = {}, index = 0 } = _param, props = _object_without_properties(_param, [
        "tag",
        "className",
        "style",
        "index"
    ]);
    const { animation, duration, easing, slide: { current, previous }, slideAmount } = React.useContext(SliderContext);
    const { restartEngine } = React.useContext(IXContext);
    React.useEffect(()=>{
        restartEngine && restartEngine();
    }, [
        restartEngine
    ]);
    const isSlideActive = current === index;
    const isSlidePrevious = previous === index;
    const animationStyle = React.useMemo(()=>{
        const base = {
            transform: `translateX(-${current * 100}%)`,
            transition: `transform ${duration}ms ${EASING_FUNCTIONS[easing]} 0s`
        };
        if (animation === "slide") {
            return base;
        }
        if (animation === "cross") {
            return _object_spread_props(_object_spread({}, base), {
                opacity: isSlideActive ? 1 : 0,
                transition: `opacity ${duration}ms ${EASING_FUNCTIONS[easing]} 0s, transform 1ms linear ${isSlideActive ? 0 : duration}ms`
            });
        }
        if (animation === "outin") {
            return _object_spread_props(_object_spread({}, base), {
                opacity: isSlideActive ? 1 : 0,
                transition: `opacity ${duration / 2}ms ${EASING_FUNCTIONS[easing]} ${isSlidePrevious ? 0 : duration / 2}ms, transform 1ms linear ${isSlidePrevious ? duration / 2 : 0}ms`
            });
        }
        if (animation === "fade") {
            return _object_spread_props(_object_spread({}, base), {
                opacity: isSlideActive ? 1 : 0,
                transition: `opacity ${duration}ms ${EASING_FUNCTIONS[easing]} 0s, transform 1ms linear ${isSlideActive ? 0 : duration}ms`
            });
        }
        if (animation === "over") {
            return _object_spread_props(_object_spread({}, base), {
                transition: `transform ${duration}ms ${EASING_FUNCTIONS[easing]} ${isSlidePrevious ? duration : 0}ms`,
                zIndex: isSlideActive ? 1 : 0
            });
        }
        return base;
    }, [
        animation,
        duration,
        easing,
        current,
        isSlideActive,
        isSlidePrevious
    ]);
    const innerRef = React.useCallback((node)=>{
        triggerIXEvent(node, isSlideActive);
        if (ref) {
            if (typeof ref === "function") {
                ref(node);
            } else {
                ref.current = node;
            }
        }
    }, [
        isSlideActive,
        ref
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({}, props), {
        className: cj(className, "w-slide"),
        style: _object_spread({}, style, animationStyle),
        "aria-label": `${index + 1} of ${slideAmount}`,
        role: "group",
        ref: innerRef,
        "aria-hidden": !isSlideActive ? "true" : "false"
    }));
});
export default SliderSlide;
